"use client";

import React from "react";
import { SoftwareCard } from "./SoftwareCard";
import { fontWeights } from "@/utils/fonts";

interface SoftwareItem {
    title: string;
    description: string;
    icon: string;
}

interface SoftwareServiceProps {
    title?: string;
    items?: SoftwareItem[];
    locationName?: string;
    serviceName?: string;
}

export function SoftwareService({ title, items = [], locationName, serviceName }: SoftwareServiceProps) {
    const replaceDynamicPlaceholders = (text: string | undefined) => {
        if (!text) return "";
        return text
            .replace(/{location}/g, locationName || "")
            .replace(/{service}/g, serviceName || "");
    };

    const displayItems = items || [];

    const firstRow = displayItems.slice(0, 3);
    const secondRow = displayItems.slice(3, 7);
    const thirdRow = displayItems.slice(7, 10);
    const finalTitle = replaceDynamicPlaceholders(title);

    return (
        <div>
            <section className="mt-0 mx-auto max-w-[1920px] max-h-auto">
                <div className=" mx-auto px-4 sm:px-6 lg:px-[30px] 2xl:px-[100px] pb-5">
                    <div className="text-center">
                        {finalTitle && (
                            <h2
                                className="
                                    mb-8
                                    sm:mb-[50px]
                                    lg:mb-[90px]
                                    xl:mb-[110px]
                                    mx-auto
                                    text-[24px] 
                                    lg:text-[35px] 
                                    2xl:text-[40px] 
                                    3xl:text-[45px] 
                                    tracking-normal
                                    text-[#000000]
                                    max-w-[1050px]
                                    h-auto
                                    "
                                style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.semiBold }}
                                dangerouslySetInnerHTML={{ __html: finalTitle }}
                            />
                        )}
                    </div>
                    <div className="flex flex-col mx-auto lg:max-w-[950px] xl:max-w-[1200px] 2xl:max-w-[1322px] max-h-auto">
                        <div className="grid grid-cols-1 lg:grid-cols-3 mx-auto gap-[8px] xl:gap-[40px] 2xl:gap-[80px]">
                            {firstRow.map((softwares) => (
                                <SoftwareCard
                                    key={softwares.title}
                                    title={replaceDynamicPlaceholders(softwares.title)}
                                    description={replaceDynamicPlaceholders(softwares.description)}
                                    icon={softwares.icon}
                                />
                            ))}
                        </div>
                        <div className="mx-auto grid grid-cols-1 lg:grid-cols-4 gap-[8px] lg:gap-[10px] 2xl:gap-[15px] my-2 lg:my-[20px] 2xl:my-[40px] ">
                            {secondRow.map((softwares) => (
                                <SoftwareCard
                                    key={softwares.title}
                                    title={replaceDynamicPlaceholders(softwares.title)}
                                    description={replaceDynamicPlaceholders(softwares.description)}
                                    icon={softwares.icon}
                                />
                            ))}
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-3 mx-auto gap-[8px] xl:gap-[40px] 2xl:gap-[80px]">
                            {thirdRow.map((softwares) => (
                                <SoftwareCard
                                    key={softwares.title}
                                    title={replaceDynamicPlaceholders(softwares.title)}
                                    description={replaceDynamicPlaceholders(softwares.description)}
                                    icon={softwares.icon}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <div
                className="
                    py-[40px]
                    sm:py-[60px]
                    lg:py-[80px]
                    2xl:py-[100px] 
                    bg-white
                "
            >
                <div className="lg:h-[1px] h-[0.95px] lg:w-[200px] w-[150px] bg-[#002F6D] mx-auto" />
            </div>
        </div>
    );
}
